// Monetag → Sites → Add zone → Direct link. The id is the zoneid in the tag.
const MONETAG_DIRECT_ZONE_ID = ''
const VIGNETTE_ZONE = '11697271'
const VIGNETTE_SRC = 'https://n6wxm.com/vignette.min.js'

const COOLDOWN_MS = 4 * 60 * 1000
const LAST_SHOWN_KEY = 'szozat-monetag-ad-at'
const SKIPPED_FIRST_KEY = 'szozat-monetag-skipped-first'
const ARMED_KEY = 'szozat-monetag-armed'

const smartLink = MONETAG_DIRECT_ZONE_ID
  ? `//go.oclasrv.com/afu.php?zoneid=${MONETAG_DIRECT_ZONE_ID}`
  : ''

function hasSessionStorage(): boolean {
  return typeof window !== 'undefined' && typeof sessionStorage !== 'undefined'
}

export function noteRoundEnded(): void {
  if (!hasSessionStorage()) return

  if (!sessionStorage.getItem(SKIPPED_FIRST_KEY)) {
    sessionStorage.setItem(SKIPPED_FIRST_KEY, '1')
    return
  }

  sessionStorage.setItem(ARMED_KEY, '1')
}

export function claimBreakSlot(): boolean {
  if (!hasSessionStorage()) return false
  if (sessionStorage.getItem(ARMED_KEY) !== '1') return false

  sessionStorage.removeItem(ARMED_KEY)

  const lastShown = Number(localStorage.getItem(LAST_SHOWN_KEY) || '0')
  if (Number.isFinite(lastShown) && Date.now() - lastShown < COOLDOWN_MS) {
    return false
  }

  return true
}

export function markBreakShown(): void {
  if (typeof localStorage === 'undefined') return
  localStorage.setItem(LAST_SHOWN_KEY, String(Date.now()))
}

export function openMonetagAd(): void {
  if (!smartLink || typeof window === 'undefined') return
  const opened = window.open(smartLink, 'ad')
  if (opened) markBreakShown()
}

export function initMonetagVignette(): void {
  if (typeof document === 'undefined') return
  if (document.querySelector(`script[data-zone="${VIGNETTE_ZONE}"]`)) return

  const script = document.createElement('script')
  script.dataset.zone = VIGNETTE_ZONE
  script.src = VIGNETTE_SRC
  document.head.appendChild(script)
}
